import { createFileRoute } from '@tanstack/react-router'
import { ChatsPage } from '@/features/storefront-chat/chats-page'

export const Route = createFileRoute('/_authenticated/customer-comms/chats/$conversationId')({
  staticData: { title: 'Chats', phoneFullScreen: true },
  component: ChatRoute,
})

function ChatRoute() {
  const { conversationId } = Route.useParams()
  return <ChatsPage conversationId={conversationId} />
}
